import * as React from "react"

import Tabs from "shared/components/Tabs"
import { SkuId } from "shared/hubrise/ids"
import { IProduct, ISku } from "shared/hubrise/models"
import { findById } from "shared/utils/javascript"

import SkuOptionLists from "./SkuOptionLists"
import { Sku } from "./Styles"

interface MultiSkuProps {
  product: IProduct
}

const MultiSku = ({ product }: MultiSkuProps): JSX.Element => {
  const [activeSkuId, setActiveSkuId] = React.useState<SkuId>(product.skus[0].id)

  // Update the active SKU if the current one has been deleted.
  const activeSku: ISku = findById(product.skus, activeSkuId) ?? product.skus[0]
  React.useEffect(() => {
    if (activeSku.id !== activeSkuId) setActiveSkuId(activeSku.id)
  }, [activeSku.id, activeSkuId])

  return (
    <>
      <Tabs
        items={product.skus}
        selectedItem={activeSku}
        onSelect={({ id }) => setActiveSkuId(id)}
        label={({ name }) => name}
      />

      <Sku key={activeSku.id}>
        <SkuOptionLists product={product} sku={activeSku} />
      </Sku>
    </>
  )
}

export default MultiSku
